var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置签名",
            visible: _vm.signQrcodeDialogVisible,
            width: "300px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.signQrcodeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "font-weight": "bold",
                "font-size": "16px",
                "text-align": "center",
              },
            },
            [_vm._v(" 检测到未设置签名 ")]
          ),
          _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "font-weight": "bold",
                "font-size": "16px",
                "text-align": "center",
              },
            },
            [_vm._v(" 请用手机扫描二维码设置签名 ")]
          ),
          _c(
            "div",
            { staticStyle: { width: "100%", "text-align": "center" } },
            [_c("vue-qr", { attrs: { size: 200, text: _vm.signQrcode } })],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.signQrcodeDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }